module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-regular.woff
// module id = bT6D
// module chunks = 0